<ng-container *transloco="let t">
  <IBadge
    class="cursor-default"
    [label]="badgeConfig().label"
    [color]="badgeConfig().color"
    [variant]="badgeConfig().variant"
    size="xs"
    [icon]="badgeConfig().icon"
    [iTooltip]="noTooltip() ? undefined : badgeConfig().tooltip"
    iTooltipWidth="250"
    iTooltipPlacement="top-center"
  />
</ng-container>
